"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class AdminTheme extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      theme: undefined
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (prevProps.theme !== this.props.theme) {
        this.getTheme();
      }
    });

    _defineProperty(this, "getContrast", color => {
      let contrast;
      color = (0, _color.default)(color);

      if (color.isDark()) {
        contrast = 'white';
      } else {
        contrast = 'black';
      }

      return contrast;
    });

    _defineProperty(this, "getTheme", () => {
      let theme = this.props.theme;

      if (!(theme && theme.primaryColor)) {
        this.setState({
          theme: false
        });
      }

      let primaryColor = theme.primaryColor,
          secondaryColor = theme.secondaryColor;

      if (!secondaryColor) {
        secondaryColor = primaryColor;
      }

      primaryColor = (0, _color.default)(primaryColor);
      secondaryColor = (0, _color.default)(secondaryColor);
      const primaryContrast = this.getContrast(primaryColor);
      const secondaryContrast = this.getContrast(secondaryColor);
      let primaryDark = "#666";
      let primaryLight = "#999";

      if (primaryColor.isDark()) {
        primaryDark = primaryColor;
      } else {
        primaryLight = primaryColor;
      }

      this.setState({
        theme: {
          primaryColor: primaryColor,
          primaryContrast: primaryContrast,
          secondaryColor: secondaryColor,
          secondaryContrast: secondaryContrast,
          primaryDark: primaryDark,
          primaryLight: primaryLight
        }
      });
    });

    _defineProperty(this, "renderStyle", () => {
      const theme = this.state.theme;

      if (!theme) {
        return false;
      }

      const primaryColor = theme.primaryColor,
            primaryContrast = theme.primaryContrast,
            secondaryColor = theme.secondaryColor,
            secondaryContrast = theme.secondaryContrast,
            primaryDark = theme.primaryDark,
            primaryLight = theme.primaryLight;
      return _react.default.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "          \n\n        .bg-primary {\n          background-color: " + primaryColor + ";\n          color: " + primaryContrast + ";\n        }\n\n        .bg-secondary {\n          background-color: " + secondaryColor + ";\n          color: " + secondaryContrast + ";\n        }\n\n        .bg-dark {\n          background-color: " + primaryDark + ";\n          color: white;\n        }\n\n        .bg-light {\n          background-color: " + primaryLight + ";\n          color: black;\n        }\n        \n        .color-primary {\n          color: " + primaryColor + ";\n        }\n\n        .color-primary-contrast {\n          color: " + primaryContrast + ";\n        }\n\n        .color-secondary {\n          color: " + secondaryColor + ";\n        }\n\n        .color-secondary-contrast {\n          color: " + secondaryContrast + ";\n        }\n\n        .color-dark {\n          color: " + primaryDark + ";\n        }\n\n        .color-light {\n          color: " + primaryLight + ";\n        }\n        \n        .nav-action .admin-button--primary {\n          background-color: " + primaryDark + ";\n          color: white;\n        }\n\n        .nav-path .admin-button[aria-selected=\"true\"] {\n          color: " + primaryDark + ";\n        }\n        \n        a {\n          color: " + primaryDark + ";\n        }\n        \n      "
        }
      });
    });
  }

  componentDidMount() {
    this.getTheme();
  }

  render() {
    const theme = this.state.theme;

    if (!(theme && theme.primaryColor)) {
      return this.props.children;
    }

    return _react.default.createElement("div", {
      className: "admin__theme"
    }, this.renderStyle(), this.props.children);
  }

}

_defineProperty(AdminTheme, "defaultProps", {
  theme: {
    primaryColor: '#666'
  }
});

var _default = AdminTheme;
exports.default = _default;
module.exports = exports.default;